<template>
  <div>
    <div
      v-for="(newsItem, index) in newsList.data"
      class="news-card"
      :key="'new-item-' + index"
    >
      <facebook-loader
        v-if="loading"
        :speed="1"
        :animate="true"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
      </facebook-loader>
      <div v-else>
        <h2 class="news-title"><i
            v-if="newsItem.pinned"
            class="fa fa-thumb-tack"
            aria-hidden="true"
          ></i> {{ newsItem.title }} </h2>
        <div class="news-meta">
          <p v-if="authUserRole == 'member'">
            <label>{{ newsItem.user_role | capitalize }} <i class="fa fa-clock-o"></i> {{ $t('form.published') }} <span>{{ labelDate(newsItem.created_at)  }}</span></label>
          </p>
          <p v-else>
            <label><span class="meta-head">{{ newsItem.user_role | capitalize }}</span> | {{ newsItem.username  }}</label>
            <br /><i class="fa fa-clock-o"></i> {{ $t('form.published') }} <span>{{ labelDate(newsItem.created_at)  }}</span>
          </p>
        </div>
        <p
          v-html="newsItem.description"
          class="news-description"
        ></p>
      </div>
    </div>
    <div class="col-12 news-pagination">
      <b-pagination
        size="md"
        :total-rows="newsList.total"
        v-model="currentPage"
        :per-page="newsList.perPage"
        :limit="5"
        align="center"
        :prev-text="labelText.prev"
        :next-text="labelText.next"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import apiNews from "../api/news";
// import bPagination from 'bootstrap-vue/es/components/pagination/pagination'
import { FacebookLoader } from "vue-content-loader";

export default {
  name: "news-list",
  components: {
    // bPagination,
    FacebookLoader
  },
  props: ["per_page"],
  data() {
    return {
      authUserRole: "",
      newsList: [],
      currentPage: 1,
      lang: "",
      loading: true,
      labelText: {
        prev: this.$t("navigator.prev"),
        next: this.$t("navigator.next")
      }
    };
  },
  mounted() {
    this.getLanguage();
    this.loadData();
  },
  methods: {
    getLanguage() {
      const language = window.Config.LOCALE;
      const segments = language.split("_");
      if (!_.isEmpty(segments[0])) {
        this.lang = segments[0];
      }
    },
    loadData() {
      apiNews.getNews(
        response => {
          this.newsList = _.get(response, "data.news");
          this.authUserRole = _.get(response, "data.authUserRole");
          let self = this;
          setTimeout(function() {
            self.loading = false;
          }, 800);
        },
        error => {
          this.handleErrorMessage(error);
        },
        {
          page: this.currentPage,
          params: {
            per_page: this.per_page
          }
        }
      );
    },
    labelDate(date) {
      const dayMouth = moment(date)
        .locale(this.lang)
        .format("D MMMM");
      let year = moment(date)
        .locale(this.lang)
        .format("YYYY");
      this.lang == "th" ? (year = +year + 543) : 0;
      const time = moment(date)
        .locale(this.lang)
        .format("HH:mm");
      return (
        dayMouth +
        " " +
        year +
        " " +
        this.$t("form.time") +
        " " +
        time +
        " " +
        this.$t("form.time_a")
      );
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    currentPage: function() {
      this.loading = true;
      return this.loadData();
    }
  }
};
</script>
<style>
.news-card {
  padding: 20px;
  background-color: #fff;
  margin-top: 10px;
  border-radius: 3px;
}
.news-card i.fa-thumb-tack {
  color: #940000;
}
.news-title {
  color: #000;
  font-weight: 400;
}
.news-description,
.news-meta label {
  font-family: Arial, sans-serif;
}
.news-description font {
  line-height: 25px;
}
.news-meta {
  color: #b2b2b2;
  border-bottom: dashed 1px #ccc;
}
.news-description {
  padding-top: 10px;
  min-height: 200px;
}
.news-description img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.news-pagination {
  padding-top: 10px;
}
.pagination {
  display: flex;
}
.justify-content-end {
  -ms-flex-pack: end !important;
  justify-content: flex-end !important;
}
.justify-content-center {
  -ms-flex-pack: center !important;
  justify-content: center !important;
}
#news-list.ibox-content {
  padding: 0px;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/NewsList.vue